import React, { useEffect, useState } from 'react'
import { PointSpreadLoading } from 'react-loadingg'
import {getSupermarketsOfferListLimit } from '../../Api/BarestServices'
import More from '../../Component/More/More'
import Style from './SeeMore.module.css'
import { errorToast } from '../../Toast/Toast'
const SeeMore = (props) => {
    const data=props.location.state
    const[moreDiscount,setMoreDiscount]=useState()
    useEffect(()=>{
        getDiscount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]) 
 
    const getDiscount=async()=>{
        getSupermarketsOfferListLimit(data,(succ,res)=>{
            if(succ){
                if(res.status===0){
                    errorToast("مشکلی پیش آمده است")
                }else{
                    setMoreDiscount(res.products)
                }
            }else{
              console.error(res)
            }
        }) 
    }
   
    return (
        <div className={Style.pageHolder}>
            {moreDiscount===undefined ? 
            <div>
                 <PointSpreadLoading color={'#ab0c59'} size={"small"} />
            </div>
            :
            <More data={moreDiscount} title={"تخفیفات"} headerText={"در بَرِست از تخفیف ها لذت ببرید"} category={getDiscount} supery={true}/>
            }
        </div>
    )
}

export default SeeMore